import styled from 'styled-components'
import { grayLighter, white } from 'utils/style-utils'

export const InfoBox = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem;
  justify-content: space-around;
`

export const InfoRow = styled.div``

export const Info = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0.5rem 0;
  height: 2rem;
  color: ${grayLighter};
  font-size: 0.875rem;
`

export const Label = styled.span``

export const Value = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  font-weight: 700;
  color: ${white};
`

export const ProducerIconBox = styled.div`
  svg {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    fill: ${white};
  }
`
